<template>
	<div class="switch-field-settings field-settings">
		<v-expansion-panels v-model="panel" flat accordion>
			<ExpansionPanel :title="'Basics'">
				<SettingSwitch
					:title="'Label'"
					:placeholder="'Type your title here'"
					:switchValue.sync="titleEnabledWrapper"
					:textFieldValue.sync="titleValue"
				/>
				<div class="field-setting-section">
					<div class="section-title">Toggle Label:</div>
					<AppTextField outlined hide-details v-model="switchLabel" />
				</div>
				<SettingSwitch class="mt-4" :title="'True required'" :switchValue.sync="requiredEnabled" />
				<div class="field-setting-section">
					<SettingSwitch :title="'Prefill'" :switchValue.sync="prefillEnabled" />
					<div class="align-center mb-4 prefill-row" v-if="prefillEnabled">
						<CombinedInputFieldDataMenu
							:value.sync="prefillValue"
							:textAreaMode="false"
							:attachTo="'.prefill-row'"
							:valuesTypes="dataInputMenuValueTypes"
							:richTextFormat="null"
						/>
						<div class="font-size-sm subtle-message mt-1">Write 'true' for On, 'false' for Off</div>
					</div>
				</div>
			</ExpansionPanel>
		</v-expansion-panels>
	</div>
</template>

<script>
import FieldSettingsMixin from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';
import ItemOnlyAllowedValueTypesMixin from '../ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';

import SettingSwitch from '../WidgetSettings/SettingSwitch';
import ExpansionPanel from '../WidgetSettings/ExpansionPanel';

export default {
	name: 'SwitchFieldSettings',
	mixins: [FieldSettingsMixin, ItemOnlyAllowedValueTypesMixin],
	components: {
		ExpansionPanel,
		SettingSwitch,
	},
	computed: {
		titleEnabledWrapper: {
			set(value) {
				this.titleEnabled = value;
			},
			get() {
				return this.titleEnabled;
			},
		},
		switchLabel: {
			get() {
				return this.localField.metadata.options.switch_label || [];
			},
			set(value) {
				this.setLocalFieldKey('metadata.options.switch_label', value);
			},
		},
	},
};
</script>

<style scoped lang="scss">
.switch-field-settings {
}
</style>
